// extracted by mini-css-extract-plugin
export var blue = "_n-f";
export var brand = "_n-b";
export var darkGrey = "_n-e";
export var disabled = "_n-4";
export var disabledSubtle = "_n-5";
export var error = "_n-6";
export var green = "_n-g";
export var grey = "_n-d";
export var icon = "_n-0";
export var inherit = "_n-a";
export var lightGrey = "_n-c";
export var orange = "_n-i";
export var pink = "_n-k";
export var primary = "_n-1";
export var purple = "_n-l";
export var red = "_n-j";
export var secondary = "_n-2";
export var success = "_n-9";
export var tertiary = "_n-3";
export var warning = "_n-7";
export var warningSecondary = "_n-8";
export var white = "_n-m";
export var yellow = "_n-h";